import { render, staticRenderFns } from "./examineDeadline.vue?vue&type=template&id=16ec7fae&scoped=true"
import script from "./examineDeadline.vue?vue&type=script&lang=js"
export * from "./examineDeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ec7fae",
  null
  
)

export default component.exports